/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CustomResultOfListOfBrandDto } from '../models/custom-result-of-list-of-brand-dto';
import { CustomResultOfListOfCheckPolygonHaveCellDto } from '../models/custom-result-of-list-of-check-polygon-have-cell-dto';
import { CustomResultOfListOfDeviceTypeDto } from '../models/custom-result-of-list-of-device-type-dto';
import { CustomResultOfListOfGetAirportsDto } from '../models/custom-result-of-list-of-get-airports-dto';
import { CustomResultOfListOfGetCellListDto } from '../models/custom-result-of-list-of-get-cell-list-dto';
import { CustomResultOfListOfGetCellsByNamesQueryDto } from '../models/custom-result-of-list-of-get-cells-by-names-query-dto';
import { CustomResultOfListOfGetCitiesDto } from '../models/custom-result-of-list-of-get-cities-dto';
import { CustomResultOfListOfGetDeviceModelsByBrandDto } from '../models/custom-result-of-list-of-get-device-models-by-brand-dto';
import { CustomResultOfListOfGetProvincesDto } from '../models/custom-result-of-list-of-get-provinces-dto';
import { smartSmsCheckPolygonHaveCell } from '../fn/smart-sms/smart-sms-check-polygon-have-cell';
import { SmartSmsCheckPolygonHaveCell$Params } from '../fn/smart-sms/smart-sms-check-polygon-have-cell';
import { smartSmsGetAirports } from '../fn/smart-sms/smart-sms-get-airports';
import { SmartSmsGetAirports$Params } from '../fn/smart-sms/smart-sms-get-airports';
import { smartSmsGetBrands } from '../fn/smart-sms/smart-sms-get-brands';
import { SmartSmsGetBrands$Params } from '../fn/smart-sms/smart-sms-get-brands';
import { smartSmsGetCellList } from '../fn/smart-sms/smart-sms-get-cell-list';
import { SmartSmsGetCellList$Params } from '../fn/smart-sms/smart-sms-get-cell-list';
import { smartSmsGetCellsByNames } from '../fn/smart-sms/smart-sms-get-cells-by-names';
import { SmartSmsGetCellsByNames$Params } from '../fn/smart-sms/smart-sms-get-cells-by-names';
import { smartSmsGetCities } from '../fn/smart-sms/smart-sms-get-cities';
import { SmartSmsGetCities$Params } from '../fn/smart-sms/smart-sms-get-cities';
import { smartSmsGetDeviceModelsByBrand } from '../fn/smart-sms/smart-sms-get-device-models-by-brand';
import { SmartSmsGetDeviceModelsByBrand$Params } from '../fn/smart-sms/smart-sms-get-device-models-by-brand';
import { smartSmsGetDeviceTypes } from '../fn/smart-sms/smart-sms-get-device-types';
import { SmartSmsGetDeviceTypes$Params } from '../fn/smart-sms/smart-sms-get-device-types';
import { smartSmsGetProvinces } from '../fn/smart-sms/smart-sms-get-provinces';
import { SmartSmsGetProvinces$Params } from '../fn/smart-sms/smart-sms-get-provinces';

@Injectable({ providedIn: 'root' })
export class SmartSmsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `smartSmsGetDeviceTypes()` */
  static readonly SmartSmsGetDeviceTypesPath = '/SmartSms/GetDeviceTypes';

  /**
   * دریافت لیست انواع دستگاه.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `smartSmsGetDeviceTypes()` instead.
   *
   * This method doesn't expect any request body.
   */
  smartSmsGetDeviceTypes$Response(params?: SmartSmsGetDeviceTypes$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfDeviceTypeDto>> {
    return smartSmsGetDeviceTypes(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت لیست انواع دستگاه.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `smartSmsGetDeviceTypes$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  smartSmsGetDeviceTypes(params?: SmartSmsGetDeviceTypes$Params, context?: HttpContext): Observable<CustomResultOfListOfDeviceTypeDto> {
    return this.smartSmsGetDeviceTypes$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfDeviceTypeDto>): CustomResultOfListOfDeviceTypeDto => r.body)
    );
  }

  /** Path part for operation `smartSmsGetBrands()` */
  static readonly SmartSmsGetBrandsPath = '/SmartSms/GetBrands';

  /**
   * دریافت لیست انواع برند ها.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `smartSmsGetBrands()` instead.
   *
   * This method doesn't expect any request body.
   */
  smartSmsGetBrands$Response(params?: SmartSmsGetBrands$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfBrandDto>> {
    return smartSmsGetBrands(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت لیست انواع برند ها.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `smartSmsGetBrands$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  smartSmsGetBrands(params?: SmartSmsGetBrands$Params, context?: HttpContext): Observable<CustomResultOfListOfBrandDto> {
    return this.smartSmsGetBrands$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfBrandDto>): CustomResultOfListOfBrandDto => r.body)
    );
  }

  /** Path part for operation `smartSmsGetDeviceModelsByBrand()` */
  static readonly SmartSmsGetDeviceModelsByBrandPath = '/SmartSms/GetDeviceModelsByBrand';

  /**
   * دریافت لیست انواع مدل های یک برند.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `smartSmsGetDeviceModelsByBrand()` instead.
   *
   * This method doesn't expect any request body.
   */
  smartSmsGetDeviceModelsByBrand$Response(params?: SmartSmsGetDeviceModelsByBrand$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfGetDeviceModelsByBrandDto>> {
    return smartSmsGetDeviceModelsByBrand(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت لیست انواع مدل های یک برند.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `smartSmsGetDeviceModelsByBrand$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  smartSmsGetDeviceModelsByBrand(params?: SmartSmsGetDeviceModelsByBrand$Params, context?: HttpContext): Observable<CustomResultOfListOfGetDeviceModelsByBrandDto> {
    return this.smartSmsGetDeviceModelsByBrand$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfGetDeviceModelsByBrandDto>): CustomResultOfListOfGetDeviceModelsByBrandDto => r.body)
    );
  }

  /** Path part for operation `smartSmsGetProvinces()` */
  static readonly SmartSmsGetProvincesPath = '/SmartSms/GetProvinces';

  /**
   * دریافت لیست استان ها.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `smartSmsGetProvinces()` instead.
   *
   * This method doesn't expect any request body.
   */
  smartSmsGetProvinces$Response(params?: SmartSmsGetProvinces$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfGetProvincesDto>> {
    return smartSmsGetProvinces(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت لیست استان ها.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `smartSmsGetProvinces$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  smartSmsGetProvinces(params?: SmartSmsGetProvinces$Params, context?: HttpContext): Observable<CustomResultOfListOfGetProvincesDto> {
    return this.smartSmsGetProvinces$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfGetProvincesDto>): CustomResultOfListOfGetProvincesDto => r.body)
    );
  }

  /** Path part for operation `smartSmsGetCities()` */
  static readonly SmartSmsGetCitiesPath = '/SmartSms/GetCities';

  /**
   * دریافت لیست شهر ها.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `smartSmsGetCities()` instead.
   *
   * This method doesn't expect any request body.
   */
  smartSmsGetCities$Response(params?: SmartSmsGetCities$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfGetCitiesDto>> {
    return smartSmsGetCities(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت لیست شهر ها.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `smartSmsGetCities$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  smartSmsGetCities(params?: SmartSmsGetCities$Params, context?: HttpContext): Observable<CustomResultOfListOfGetCitiesDto> {
    return this.smartSmsGetCities$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfGetCitiesDto>): CustomResultOfListOfGetCitiesDto => r.body)
    );
  }

  /** Path part for operation `smartSmsGetAirports()` */
  static readonly SmartSmsGetAirportsPath = '/SmartSms/GetAirports';

  /**
   * دریافت لیست فرودگاه ها.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `smartSmsGetAirports()` instead.
   *
   * This method doesn't expect any request body.
   */
  smartSmsGetAirports$Response(params?: SmartSmsGetAirports$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfGetAirportsDto>> {
    return smartSmsGetAirports(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت لیست فرودگاه ها.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `smartSmsGetAirports$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  smartSmsGetAirports(params?: SmartSmsGetAirports$Params, context?: HttpContext): Observable<CustomResultOfListOfGetAirportsDto> {
    return this.smartSmsGetAirports$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfGetAirportsDto>): CustomResultOfListOfGetAirportsDto => r.body)
    );
  }

  /** Path part for operation `smartSmsGetCellList()` */
  static readonly SmartSmsGetCellListPath = '/SmartSms/GetCellList';

  /**
   * دریافت لیست سلول ها.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `smartSmsGetCellList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  smartSmsGetCellList$Response(params: SmartSmsGetCellList$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfGetCellListDto>> {
    return smartSmsGetCellList(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت لیست سلول ها.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `smartSmsGetCellList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  smartSmsGetCellList(params: SmartSmsGetCellList$Params, context?: HttpContext): Observable<CustomResultOfListOfGetCellListDto> {
    return this.smartSmsGetCellList$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfGetCellListDto>): CustomResultOfListOfGetCellListDto => r.body)
    );
  }

  /** Path part for operation `smartSmsGetCellsByNames()` */
  static readonly SmartSmsGetCellsByNamesPath = '/SmartSms/GetCellsByNames';

  /**
   * دریافت لیست سلول ها.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `smartSmsGetCellsByNames()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  smartSmsGetCellsByNames$Response(params: SmartSmsGetCellsByNames$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfGetCellsByNamesQueryDto>> {
    return smartSmsGetCellsByNames(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت لیست سلول ها.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `smartSmsGetCellsByNames$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  smartSmsGetCellsByNames(params: SmartSmsGetCellsByNames$Params, context?: HttpContext): Observable<CustomResultOfListOfGetCellsByNamesQueryDto> {
    return this.smartSmsGetCellsByNames$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfGetCellsByNamesQueryDto>): CustomResultOfListOfGetCellsByNamesQueryDto => r.body)
    );
  }

  /** Path part for operation `smartSmsCheckPolygonHaveCell()` */
  static readonly SmartSmsCheckPolygonHaveCellPath = '/SmartSms/CheckPolygonHaveCell';

  /**
   * بررسی وجود سلول.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `smartSmsCheckPolygonHaveCell()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  smartSmsCheckPolygonHaveCell$Response(params: SmartSmsCheckPolygonHaveCell$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfCheckPolygonHaveCellDto>> {
    return smartSmsCheckPolygonHaveCell(this.http, this.rootUrl, params, context);
  }

  /**
   * بررسی وجود سلول.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `smartSmsCheckPolygonHaveCell$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  smartSmsCheckPolygonHaveCell(params: SmartSmsCheckPolygonHaveCell$Params, context?: HttpContext): Observable<CustomResultOfListOfCheckPolygonHaveCellDto> {
    return this.smartSmsCheckPolygonHaveCell$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfCheckPolygonHaveCellDto>): CustomResultOfListOfCheckPolygonHaveCellDto => r.body)
    );
  }

}
